import React, { FC } from "react";
import { previousInjuriesItems } from "./previousInjuries";
import { useWebTranslation } from "translations";
import { Typography } from "ui-kit/Typography";

type Props = { id: string; name: string };

export const PreviousInjuriesOverviewItem: FC<Props> = (props) => {
  const { t } = useWebTranslation();

  const item = previousInjuriesItems.find((item) => item.id === props.id);

  if (!item) {
    return null;
  }

  return (
    <div style={{ cursor: "pointer" }}>
      <Typography component="div">
        {t(item.title, { name: props.name })}
      </Typography>
      <Typography>{t(item.overviewText, { name: props.name })}</Typography>
    </div>
  );
};
